'use strict';


/* eslint max-lines-per-function: ['error', {max: 400, skipBlankLines: true, skipComments: true}] */
/* eslint max-statements: ['warn', 74, {ignoreTopLevelFunctions: false}], */
var Intent = require('./intent'),
    Core   = require('../kernel/core'),

    systemConfig  = require('../tools/config'),

    splash = require('../../components/splash'),

    intentMap = {},
    hooks     = {},

    // lazy required modules
    taskManager = null,
    coreManager = null,

    intentRouter = {
        lastRoute: null,
        create: function ( config, callback ) {
            return new Intent(config, callback);
        },
        route: function ( intent, callerCoreInstance, selfCall ) {
            var result = {
                    runConfig: null,
                    handlerList: null
                },
                config;

            if ( DEVELOP ) {
                debug('intent')('route intent with action: ' + intent.action);
                debug('intent')('route core.pid: ' + callerCoreInstance.pid);
            }

            if ( coreManager === null ) {
                coreManager = require('../kernel/core.manager');
            }
            if ( taskManager === null ) {
                taskManager = require('./task.manager');
            }

            if ( intent.context ) {
                // try to resolve previous config
                if ( DEVELOP ) {
                    debug('intent')('try resolve intent with existing context, pid: ' + intent.context.pid);
                }
                if ( typeof intent.context.pid === 'undefined' ) {
                    intent.state = Intent.prototype.STATE_NOT_RESOLVED;
                    if ( DEVELOP ) {
                        debug('intent')('no pid in context');
                    }
                } else {
                    intent.state = Intent.prototype.STATE_RESOLVED;

                    intent.receiver = intent.context.pid;
                    intent.creator  = callerCoreInstance.pid;

                    this.lastRoute = {
                        intent: intent,
                        core: callerCoreInstance
                    };

                    if ( DEVELOP ) {
                        debug('intent')('receiver ' + intent.receiver);
                        debug('intent')('creator ' + intent.creator);
                    }

                    if ( !selfCall && hooks['before:' + intent.action] ) {
                        if ( DEVELOP ) {
                            debug('intent')('hooks[before:' + intent.action + ']');
                        }
                        hooks['before:' + intent.action].forEach(function ( hookCallback ) {
                            hookCallback(intent, taskManager.apps[callerCoreInstance.pid]);
                        });
                        if ( intent.state === Intent.prototype.STATE_PAUSED ) {
                            intent.continueCallback = function () {
                                intentRouter.route(intent, callerCoreInstance, true);
                            };

                            result.handlerList = null;

                            return result;
                        }
                    }

                    intent.runnerConfig = taskManager.apps[callerCoreInstance.pid].config;
                    taskManager.apps[intent.context.pid].core.emit('intent', intent, function ( error, context ) {
                        if ( DEVELOP ) {
                            debug('intent')('intent with context callback result: ' + (!error));
                        }

                        if ( hooks[intent.action] ) {
                            hooks[intent.action].forEach(function ( hookCallback ) {
                                hookCallback(intent, taskManager.apps[callerCoreInstance.pid]);
                                if ( DEVELOP ) {
                                    debug('intent')('call hook!!!!!!!!!!!!!!');
                                }
                            });
                        }

                        if ( error ) {
                            intent.state = Intent.prototype.STATE_ERROR_RECEIVED;
                            if ( DEVELOP ) {
                                debug('intent')('error in intent callback');
                            }
                            if ( intent.callback ) {
                                if ( DEVELOP ) {
                                    debug('intent')('context: ' + context.pid);
                                }
                                intent.callback(error, context);
                            }
                        } else {
                            intent.state = Intent.prototype.STATE_CONTEXT_RECEIVED;
                            if ( DEVELOP ) {
                                debug('intent')('context: ' + context.pid);
                            }
                            context.pid = intent.context.pid;

                            intent.addListener('close', function ( closeApplication ) {
                                if ( callerCoreInstance === null ) {
                                    return;
                                }

                                if ( DEVELOP ) {
                                    debug('intent')('close with context');
                                    debug('intent')('closeApplication? ' + closeApplication);
                                    debug('intent')('show caller? ' + callerCoreInstance &&
                                        callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid]);
                                }

                                if ( closeApplication ) {
                                    taskManager.close(taskManager.apps[callerCoreInstance.pid]);
                                    callerCoreInstance = null;
                                    taskManager.show(taskManager.launcher);
                                } if ( callerCoreInstance && callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid] ) {
                                    taskManager.show(taskManager.apps[callerCoreInstance.pid], {
                                        source: Core.prototype.SOURCES.INTENT,
                                        data: {
                                            intent: intent
                                        }
                                    });
                                } else {
                                    callerCoreInstance = null;
                                    taskManager.show(taskManager.launcher);
                                }
                            });

                            if ( intent.callback ) {
                                if ( DEVELOP ) {
                                    debug('intent')('context: ' + context.pid);
                                }
                                //intent.callback(false, context);
                            }
                        }
                    });
                }

                return result;
            }

            result.handlerList = this.findIntentHandlers(intent);
            if ( result.handlerList.length > 0 ) {
                intent.state = Intent.prototype.STATE_RESOLVED;
                config = result.handlerList[0];

                this.lastRoute = {
                    intent: intent,
                    core: callerCoreInstance
                };

                // if ( taskManager.home && !firstHomeIntent && taskManager.home.core === callerCoreInstance ) {
                //     setInterval(function () {
                //         console.log(taskManager.home.$iframe.isVisible);
                //     }, 50)
                //     taskManager.home.$iframe.hide();
                //     setTimeout(function () {
                //         taskManager.home.$iframe.hide();
                //     }, 0);
                //     firstHomeIntent = true;
                // }

                if ( typeof config.pid !== 'undefined' && taskManager.apps[config.pid] ) {
                    if ( taskManager.apps[callerCoreInstance.pid] ) {
                        intent.runnerConfig = taskManager.apps[callerCoreInstance.pid].config;
                    } else if ( taskManager.focusedApp ) {
                        intent.runnerConfig = taskManager.focusedApp.config;
                    }
                    if ( taskManager.apps[config.pid].core ) {
                        intent.receiver = config.pid;
                        intent.creator  = callerCoreInstance.pid;
                        if ( DEVELOP ) {
                            debug('intent')('receiver ' + intent.receiver);
                            debug('intent')('creator ' + intent.creator);
                        }

                        if ( !selfCall && hooks['before:' + intent.action] ) {
                            if ( DEVELOP ) {
                                debug('intent')('hooks[before:' + intent.action + ']');
                            }
                            hooks['before:' + intent.action].forEach(function ( hookCallback ) {
                                hookCallback(intent, taskManager.apps[callerCoreInstance.pid]);
                            });

                            if ( intent.state === Intent.prototype.STATE_PAUSED ) {
                                taskManager.apps[callerCoreInstance.pid].$iframe.hide();
                                intent.continueCallback = function () {
                                    if ( intent.silent ) {
                                        taskManager.apps[callerCoreInstance.pid].$iframe.show();
                                    }

                                    intentRouter.route(intent, callerCoreInstance, true);
                                };

                                result.handlerList = null;

                                return result;
                            }
                        }

                        if ( DEVELOP ) {
                            debug('intent')('emit intent ' + config.name);
                            debug('intent')(config.pid);
                            debug('intent')(Object.keys(taskManager.apps).length);
                        }

                        taskManager.apps[config.pid].core.emit('intent', intent, function ( error, context ) {
                            if ( DEVELOP ) {
                                debug('intent')('CALLBACK');
                                debug('intent')('error: ' + error);
                                debug('intent')(intent.action);
                            }
                            if ( hooks[intent.action] ) {
                                hooks[intent.action].forEach(function ( hookCallback ) {
                                    hookCallback(intent, taskManager.apps[callerCoreInstance.pid]);
                                    if ( DEVELOP ) {
                                        debug('intent')('call hook!!!!!!!!!!!!!!');
                                    }
                                });
                            }
                            context = context || {};
                            context.pid = config.pid;
                            if ( intent.silent ) {
                                if ( DEVELOP ) {
                                    debug('intent')('silent intent');
                                }
                                if ( intent.callback ) {
                                    if ( DEVELOP ) {
                                        debug('intent')('context: ' +  context.pid);
                                    }
                                    intent.callback(error, context);
                                }

                                if ( DEVELOP ) {
                                    debug('intent')('add once listener');
                                }
                                intent.once('close', function ( closeApplication ) {
                                    var task;

                                    if ( DEVELOP ) {
                                        debug('intent')('intent close');
                                        debug('intent')('intent close application? ' + closeApplication);
                                        debug('intent')(callerCoreInstance && callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid]);
                                    }

                                    if ( closeApplication ) {
                                        if ( taskManager.apps[callerCoreInstance.pid] ) {
                                            taskManager.close(taskManager.apps[callerCoreInstance.pid]);
                                        }
                                        while ( taskManager.stack.length ) {
                                            task = taskManager.stack.pop();
                                            task.$iframe.hide();
                                            task.core.emit('hide', {
                                                source: Core.prototype.SOURCES.SYSTEM
                                            });
                                        }
                                        taskManager.show(taskManager.launcher);
                                        setTimeout(function () {
                                            taskManager.topApp = null;
                                        }, 0);
                                    } else if ( callerCoreInstance && callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid] ) {
                                        taskManager.show(taskManager.apps[callerCoreInstance.pid], {
                                            source: Core.prototype.SOURCES.INTENT,
                                            data: {
                                                intent: intent
                                            }
                                        });
                                    } else {
                                        callerCoreInstance = null;
                                        while ( taskManager.stack.length ) {
                                            task = taskManager.stack.pop();
                                            task.$iframe.hide();
                                            task.core.emit('hide', {
                                                source: Core.prototype.SOURCES.INTENT,
                                                data: {
                                                    intent: intent
                                                }
                                            });
                                        }
                                        taskManager.show(taskManager.launcher);
                                        setTimeout(function () {
                                            taskManager.topApp = null;
                                        }, 0);
                                    }
                                });

                                return;
                            }

                            if ( error ) {
                                intent.state = Intent.prototype.STATE_ERROR_RECEIVED;
                                if ( DEVELOP ) {
                                    debug('intent')('error in intent callback');
                                }
                                if ( intent.callback ) {
                                    intent.callback(error, context);
                                }
                            } else {
                                intent.state = Intent.prototype.STATE_CONTEXT_RECEIVED;
                                if ( DEVELOP ) {
                                    debug('intent')('context.pid: ' +  context.pid);
                                    debug('intent')('config.pid: ' +  config.pid);
                                    debug('intent')('no error in intent callback');
                                }
                                if ( taskManager.apps[config.pid].config.type === 'osd' ) {
                                    //taskManager.apps[config.pid].core.call('show');

                                    if ( DEVELOP ) {
                                        debug('intent')('add once listener');
                                    }
                                    intent.once('close', function ( restoreApplication ) {

                                        if ( DEVELOP ) {
                                            debug('intent')('intent close');
                                            debug('intent')('intent restore application? ' + restoreApplication);
                                            debug('intent')(taskManager.apps[callerCoreInstance.pid]);
                                            debug('intent')(callerCoreInstance && callerCoreInstance.pid &&
                                                taskManager.apps[callerCoreInstance.pid]);
                                        }

                                        if ( restoreApplication && callerCoreInstance &&
                                                callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid] ) {

                                            if ( taskManager.topApp ) {
                                                taskManager.topApp.$iframe.hide();
                                                taskManager.topApp.core.applicationState.visible = false;
                                                taskManager.topApp.core.applicationState.focused = false;
                                                // taskManager.topApp.core.emit('hide', {
                                                //     source: Core.prototype.SOURCES.SYSTEM
                                                // });
                                            }
                                            taskManager.launcher.$iframe.hide();
                                            // } else if ( taskManager.launcher ) {
                                            //     taskManager.launcher.$iframe.hide();
                                            // }
                                            taskManager.topApp = null;
                                            taskManager.show(taskManager.apps[callerCoreInstance.pid]);
                                            // taskManager.apps[callerCoreInstance.pid].$iframe.contentWindow.focus();
                                            // taskManager.topApp.core.emit('focus');
                                            // taskManager.topApp = taskManager.focusedApp = taskManager.apps[callerCoreInstance.pid];
                                            // taskManager.topApp.core.emit('focus');
                                            // taskManager.topApp.$iframe.show();
                                            // taskManager.topApp.core.emit('show');
                                        }
                                    });
                                } else {
                                    if ( DEVELOP ) {
                                        debug('intent')('SHOW IN INTENT');
                                    }

                                    // if ( callerCoreInstance === taskManager.launcher.core ) {
                                    //     taskManager.launcher.$iframe.hide();
                                    // }

                                    // if ( callerCoreInstance === window.core ) {
                                    //     taskManager.launcher.$iframe.hide();
                                    // }

                                    if ( taskManager.launcher.$iframe.isVisible ) {
                                        taskManager.launcher.$iframe.hide();
                                        //taskManager.launcher.core.emit('hide');
                                        //taskManager.launcher.core.emit('blur');
                                    }

                                    taskManager.show(taskManager.apps[config.pid], {
                                        source: Core.prototype.SOURCES.INTENT,
                                        data: {
                                            intent: intent
                                        }
                                    });

                                    if ( DEVELOP ) {
                                        debug('intent')('add once listener');
                                    }
                                    intent.once('close', function ( closeApplication ) {
                                        var task;

                                        if ( DEVELOP ) {
                                            debug('intent')('intent close');
                                            debug('intent')('intent close application? ' + closeApplication);
                                            debug('intent')(callerCoreInstance && callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid]);
                                        }
                                        // if ( taskManager.apps[config.pid] ) {
                                        //     taskManager.hide(taskManager.apps[config.pid], true);
                                        // }
                                        if ( closeApplication ) {
                                            if ( taskManager.apps[callerCoreInstance.pid] ) {
                                                taskManager.close(taskManager.apps[callerCoreInstance.pid]);
                                            }
                                            while ( taskManager.stack.length ) {
                                                task = taskManager.stack.pop();
                                                task.$iframe.hide();
                                                task.core.emit('hide', {
                                                    source: Core.prototype.SOURCES.SYSTEM
                                                });
                                            }
                                            taskManager.show(taskManager.launcher);
                                            setTimeout(function () {
                                                taskManager.topApp = null;
                                            }, 0);
                                        } else if ( callerCoreInstance && callerCoreInstance.pid && taskManager.apps[callerCoreInstance.pid] ) {
                                            // if ( MODE === 'PORTAL' ) {
                                            //     taskManager.topApp = null;
                                            // }
                                            taskManager.show(taskManager.apps[callerCoreInstance.pid], {
                                                // TODO: make source as intent,after checking that everything is in ok in the player and apps
                                                source: Core.prototype.SOURCES.SYSTEM,
                                                data: {
                                                    intent: intent
                                                }
                                            });
                                        } else {
                                            callerCoreInstance = null;
                                            while ( taskManager.stack.length ) {
                                                task = taskManager.stack.pop();
                                                task.$iframe.hide();
                                                task.core.emit('hide', {
                                                    source: Core.prototype.SOURCES.SYSTEM,
                                                    data: {
                                                        intent: intent
                                                    }
                                                });
                                            }
                                            taskManager.show(taskManager.launcher);
                                            setTimeout(function () {
                                                taskManager.topApp = null;
                                            }, 0);
                                        }
                                    });
                                }
                                if ( intent.callback ) {
                                    if ( DEVELOP ) {
                                        debug('intent')('context: ' + typeof context);
                                    }
                                    intent.callback(false, context);
                                }
                            }
                        });
                    } else {
                        if ( DEVELOP ) {
                            debug('intent')('no core at pid ' + config.pid);
                        }
                        result.runConfig = config;
                    }
                } else {
                    result.handlerList = [];
                    result.runConfig = config;
                    if ( DEVELOP ) {
                        debug('intent')('no pid for action "' + intent.action + '", config.pid:' + config.pid);
                    }
                }
            } else {
                intent.state = Intent.prototype.STATE_NOT_RESOLVED;
                if ( DEVELOP ) {
                    debug('intent')('no intent handlers for action "' + intent.action + '"');
                }
            }

            return result;
        },
        findIntentHandlers: function ( intent ) {
            var handlerList = [];

            if ( intentMap[intent.action] ) {
                if ( DEVELOP ) {
                    debug('intent')('handlers for action "' + intent.action + '" size: ' + intentMap[intent.action].length);
                }

                intentMap[intent.action].forEach(function ( config ) {
                    if ( DEVELOP ) {
                        debug('intent')(JSON.stringify(config));
                    }

                    if ( intent.mime ) {
                        if ( config.actions[intent.action] !== true && config.actions[intent.action].indexOf(intent.mime) === -1 ) {
                            if ( DEVELOP ) {
                                debug('intent')('not found intent with mime: ' + intent.mime);
                            }

                            return;
                        }
                    } else if ( config.actions[intent.action] !== true ) {
                        if ( DEVELOP ) {
                            debug('intent')('not found without mime');
                        }

                        return;
                    }
                    handlerList.push(config);
                });
            }

            return handlerList;
        },
        resolveActionsConfig: function ( config ) {
            var actions, index, actionsSize, action;

            if ( DEVELOP ) {
                debug('intent')('resolveActionsConfig for ' + config.name + ', config.actions: ' + JSON.stringify(config.actions));
            }
            if ( config.actions ) {
                actions = Object.keys(config.actions);
                actionsSize = actions.length;
                index = 0;

                if ( DEVELOP ) {
                    debug('intent')('actionsSize: ' + actionsSize);
                    debug('intent')(config.pid);
                }
                while ( index < actionsSize ) {
                    action = actions[index];
                    if ( DEVELOP ) {
                        debug('intent')('action:' + action + ' - ' + JSON.stringify(config.actions[action]));
                    }
                    intentMap[action] = intentMap[action] || [];
                    config.pid = null;
                    intentMap[action].push(config);
                    ++index;
                }
            }
        },
        replaceActionsConfig: function ( oldConfig, newConfig ) {
            var actions, index, actionsSize, action;

            if ( oldConfig.actions ) {
                actions = Object.keys(oldConfig.actions);
                actionsSize = actions.length;
                index = 0;

                while ( index < actionsSize ) {
                    action = actions[index];
                    index = intentMap[action].indexOf(oldConfig);
                    if ( index !== -1 ) {
                        intentMap[action][index] = newConfig;
                    }
                    ++index;
                }
            }
        },
        addHook: function ( action, callback ) {
            hooks[action] = hooks[action] || [];
            hooks[action].push(callback);
        }
    };


/* eslint no-invalid-this: 0 */
window.extendCorePrototype('intent', function ( config, callback ) {
    var self = this,
        intent = intentRouter.create(config, callback),
        result, index, size;

    if ( DEVELOP ) {
        debug('intent')('create intent: ' + config.action);
        debug('intent')('core.pid: ' + this.pid);
        debug('intent')('splash.active: ' + splash.active);
    }

    // if ( taskManager === null ) {
    //     taskManager = require('./task.manager');
    // }

    // if ( taskManager.home && this === taskManager.home.core ) {
    //     if ( splash.active ) {
    //         splash.init();
    //         splash.hide();

    //         setTimeout(function () {
    //             if ( config && config.action ) {
    //                 result = intentRouter.route(intent, this);
    //                 if ( DEVELOP ) {
    //                     debug('intent', 'runConfig ' + result.runConfig);
    //                 }
    //                 if ( result.runConfig !== null ) {
    //                     if ( DEVELOP ) {
    //                         debug('intent')('result.runConfig: ' + JSON.stringify(result.runConfig));
    //                     }
    //                     if ( result.runConfig.pid ) {
    //                         index = 0;
    //                         size = systemConfig.data.apps.length;
    //                         while ( index < size ) {
    //                             if ( systemConfig.data.apps[index].url === result.runConfig.url ) {
    //                                 if ( DEVELOP ) {
    //                                     debug('intent')(JSON.stringify(systemConfig.data.apps[index]));
    //                                 }
    //                                 result.runConfig = systemConfig.data.apps[index] = JSON.parse(JSON.stringify(systemConfig.data.apps[index]));
    //                                 break;
    //                             }
    //                             ++index;
    //                         }
    //                     }
    //                     if ( DEVELOP ) {
    //                         debug('intent')(result.runConfig.pid);
    //                     }
    //                     taskManager.runApp({
    //                         config: result.runConfig,
    //                         visible: true,
    //                         onready: function () {
    //                             intentRouter.route(intent, self);
    //                         }
    //                     });
    //                 } else if ( result.handlerList && result.handlerList.length > 1 ) {
    //                     if ( DEVELOP ) {
    //                         debug('intent')('result.handlerList.length: ' + result.handlerList.length);
    //                     }
    //                     // maybe next time we must show modal with suggestion for intent handler
    //                 }
    //             } else {
    //                 //        debug('intent')(JSON.stringify(config));
    //             }
    //         }, 0);

    //         return intent;
    //     }
    // }


    if ( config && config.action ) {
        result = intentRouter.route(intent, this);
        if ( DEVELOP ) {
            debug('intent', 'runConfig ' + result.runConfig);
        }
        if ( result.runConfig !== null ) {
            if ( DEVELOP ) {
                debug('intent')('result.runConfig: ' + JSON.stringify(result.runConfig));
            }
            if ( result.runConfig.pid ) {
                index = 0;
                size = systemConfig.data.apps.length;

                while ( index < size ) {
                    if ( systemConfig.data.apps[index].url === result.runConfig.url ) {
                        if ( DEVELOP ) {
                            debug('intent')(JSON.stringify(systemConfig.data.apps[index]));
                        }
                        result.runConfig = systemConfig.data.apps[index] = JSON.parse(JSON.stringify(systemConfig.data.apps[index]));
                        break;
                    }
                    ++index;
                }
            }
            if ( DEVELOP ) {
                debug('intent')(result.runConfig.pid);
            }
            taskManager.runApp({
                config: result.runConfig,
                visible: true,
                onready: function () {
                    intentRouter.route(intent, self);
                }
            });
        } else if ( result.handlerList && result.handlerList.length > 1 ) {
            if ( DEVELOP ) {
                debug('intent')('result.handlerList.length: ' + result.handlerList.length);
            }
            // maybe next time we must show modal with suggestion for intent handler
        }
    } else {
        //        debug('intent')(JSON.stringify(config));
    }

    return intent;
});


window.extendCorePrototype('findIntentHandlers', function ( intent ) {
    return JSON.parse(JSON.stringify(intentRouter.findIntentHandlers(intent)));
});


window.addIntentHook = function ( action, callback ) {
    intentRouter.addHook(action, callback);
};


require('./system').addListener('home', function () {
    if ( intentRouter.lastRoute ) {
        intentRouter.lastRoute.intent.continueCallback = null;
    }
});


module.exports = intentRouter;
